import { createSlice } from '@reduxjs/toolkit';

import { getLessonReports, getLessonReportsByStudentId } from './actions';

const initialState = {
  data: [] as any[],
  currentPage: 1,
  totalPages: null as any,
  perPage: 50,
};

const lessonReportsSlice = createSlice({
  name: 'lessonReports',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getLessonReports.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(
      getLessonReportsByStudentId.fulfilled,
      (_: any, action: any) => {
        return action.payload;
      },
    );
  },
});

export default lessonReportsSlice.reducer;
